/* esm.sh - @noble/ciphers@2.1.1/_poly1305 */
export * from "/*@noble/ciphers@2.1.1/esnext/_poly1305.mjs";
